import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA4 from 'react-ga4';

import App from './App';

import './index.scss';
import './locals/i18n';

if ('serviceWorker' in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}
if(process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA4.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}
ReactDOM.render(<App/>, document.getElementById('root'));
